export function getWibDate(now: Date = new Date()): string {
	const wib = new Date(now.getTime() + 7 * 60 * 60 * 1000);
	return wib.toISOString().slice(0, 10);
}

export function getWibDateFromUtc(utcMs: number): string {
	return getWibDate(new Date(utcMs));
}

export function wibDateRangeForCron(now: Date = new Date()): {
	today: string;
	tomorrow: string;
} {
	const today = getWibDate(now);
	const tomorrowMs = now.getTime() + 24 * 60 * 60 * 1000;
	const tomorrow = getWibDate(new Date(tomorrowMs));
	return { today, tomorrow };
}

export function daysBetween(a: string, b: string): number {
	const da = new Date(`${a}T00:00:00Z`).getTime();
	const db = new Date(`${b}T00:00:00Z`).getTime();
	return Math.round((db - da) / (24 * 60 * 60 * 1000));
}

export function getWibEndOfDay(now: Date = new Date()): Date {
	const wib = new Date(now.getTime() + 7 * 60 * 60 * 1000);
	const wibDate = wib.toISOString().slice(0, 10);
	return new Date(`${wibDate}T16:59:59.999Z`);
}

export function formatQuizDate(
	date: string | Date,
	{ withYear = false }: { withYear?: boolean } = {},
): string {
	let d: Date;
	if (typeof date === "string") {
		const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
		if (m) {
			d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
		} else {
			d = new Date(date);
		}
	} else {
		d = date;
	}
	return d.toLocaleDateString("id-ID", {
		weekday: "long",
		day: "numeric",
		month: "long",
		year: withYear ? "numeric" : undefined,
	});
}
